var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.src)?_c('img',{attrs:{"src":_vm.processedSrc,"width":_vm.width,"height":_vm.height},on:{"error":_vm.handleError}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }